var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBubbles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 75,
    viewBox: "0 0 84 75",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6074,
    cy: 9.29547,
    r: 9.29547,
    fill: "#000000"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 80.0986,
    cy: 47.7167,
    r: 3.71819,
    fill: "#000000"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.4438 11.0254C82.4971 18.5484 78.8737 27.1222 71.3507 30.1755C70.5208 30.5123 69.6781 30.7679 68.8315 30.9459C64.1204 31.9367 58.8591 33.2841 56.3382 37.3856C53.3951 42.1741 55.0036 48.3927 59.3496 51.9571C68.015 59.0642 75.0268 68.4316 79.3829 79.6188C92.9059 114.348 75.7149 153.464 40.9856 166.987C6.25636 180.51 -32.8599 163.319 -46.3829 128.59C-59.9059 93.8608 -42.7149 54.7445 -7.98562 41.2215C7.18342 35.3149 23.1894 35.2679 37.5341 39.9824C42.7299 41.6901 48.6536 40.072 51.5174 35.4126L52.5823 33.68C54.694 30.2442 53.7172 25.8192 52.2006 22.0823C49.1473 14.5593 52.7707 5.9855 60.2937 2.93221C67.8167 -0.121075 76.3906 3.50236 79.4438 11.0254Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBubbles);
export default __webpack_public_path__ + "static/media/bubbles.821a499a2d8642396c8697dba9621120.svg";
export { ForwardRef as ReactComponent };